export enum PermissionGroup {
  USER = 1,
  ADMIN = 2,
}

export const PERMISSION_GROUP_NAME = {
  [PermissionGroup.USER]: 'User',
  [PermissionGroup.ADMIN]: 'Admin',
} as const;
